const { SET_ACTION_HISTORY } = require('redux/constants/ActionHistory');

const initState = {
  actionHistory: {
    count: 0,
    rows: [],
  },
  users: [],
};

const actionHistory = (state = initState, action) => {
  switch (action.type) {
    case SET_ACTION_HISTORY:
      return {
        ...state,
        actionHistory: action.actionHistory,
      };
    default:
      return state;
  }
};

export default actionHistory;
